import {
  Grid,
} from "@mui/material";
import React from "react";

import TeacherAssignmentView from "../components/Assignments/TeacherAssignmentView";

import { useUser } from "../globals/UserContext.js";
import { useAssignment } from "../globals/AssignmentContext.js";

export default function AssignmentEditor() {
  let user = useUser();
  let assignment = useAssignment();

  return (
    <Grid
    container
    spacing={2}
    direction="column"
    maxWidth="70rem"
    margin="auto"
    sx={{ paddingTop: "80px" }}>
      {user?.isTeacher ? (
          <TeacherAssignmentView assignment={assignment}/>
      ) : (
        <></>
    )}
    </Grid>
  ) 
}
